import _ from 'lodash';
import { dossierOverview } from '../bff.api';
import responseValidators from '../response.validators';

const _updateBody = (data) => {
  const result = _.pick(data, ['description', 'branch', 'theme']);
  return result;
};

const update = async (dossierId, data, options = {}) => {
  return dossierOverview
    .update(dossierId, _updateBody(data))
    .then((resp) => {
      responseValidators.updateOverview(resp);
      if (options.onSuccess) {
        options.onSuccess(resp);
      }
    })
    .catch((err) => {
      if (options.onError) {
        options.onError(err.message);
      }
    });
};

const overviewService = {
  update
};

export default overviewService;
